import { Box, CircularProgress, Paper, Typography } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import TryAgainMessageBlock from '../../components/common/TryAgainMessageBlock'
import alivelogo from '../../assets/alivelogo.png'
import api from '../../service/api'

const Verify = () => {
    const [loading, setLoading] = useState( true )
    const [error, setError] = useState( null )

    const [searchParams] = useSearchParams()
    const application_no = searchParams.get( 'application_no' )

    const navigate = useNavigate()

    const verifyUser = useCallback( async () => {
        setLoading( true )
        try {
            const { data } = await api.admissionExams.verifyCandidate( { application_no: application_no?.replace( /%2F/gi, "/" ) } )
            console.log( data )
            localStorage.setItem( "id_token", data.token )
            navigate( '/admission-exams' )
        } catch ( err ) {
            console.log( err )
            setError( { code: err?.response?.status, message: err?.response?.data?.message } )
        } finally {
            setLoading( false )
        }
    }, [application_no, navigate] )


    useEffect( () => {
        verifyUser()
    }, [verifyUser] )
    return (
        <Box sx={{ background: `url('/imgs/bg-pattern1.png')` }} display="flex" height="100%" alignItems="center" justifyContent="center">
            {loading && !error && <Paper sx={{ minWidth: "220px", padding: "20px", display: "flex", flexDirection: "column", alignItems: "center", gap: "20px" }}>
                <img width="70px" src={alivelogo} alt="Alive" />
                <Typography variant="subtitle2" display="flex" alignItems="center" gap="10px"> <CircularProgress size={14} /> Loading Alive...</Typography>
            </Paper>}
            {error && <TryAgainMessageBlock err={error?.message} code={error.code} getData={verifyUser} loading={loading} />}
        </Box>
    )
}

export default Verify
